import { render, staticRenderFns } from "./BadgetSoon.vue?vue&type=template&id=09765060&scoped=true"
import script from "./BadgetSoon.vue?vue&type=script&lang=ts"
export * from "./BadgetSoon.vue?vue&type=script&lang=ts"
import style0 from "./BadgetSoon.vue?vue&type=style&index=0&id=09765060&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09765060",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09765060')) {
      api.createRecord('09765060', component.options)
    } else {
      api.reload('09765060', component.options)
    }
    module.hot.accept("./BadgetSoon.vue?vue&type=template&id=09765060&scoped=true", function () {
      api.rerender('09765060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/main-drawer/main-drawer-item/BadgetSoon.vue"
export default component.exports